/*
 *  jquery.ih.multiautocomplete
 *
 * Create an autocomplete input that allows for multiple selections and then subsequent removal of those selections
 * For example, this is useful when selecting multiple tags or people from a smallish array of options.
 *
 *  TODO:   create a caching option for to prevent extra http requests on the same search term
 *
 *  Depends:
 *      jQuery
 *      jquery.ui.autocomplete (and all it's dependencies)
 *      appropriate styling of input wrapper and input
 *
 *
 * Sample Usage:
 * (note: the input MUST have a name attribute)
 * 
 * <input id="myinput" name="myinput" type="text">
 * 
 * $("#myinput").multiautocomplete({
 *      // same options as autocomplete
 * });
 * 
 * 
 * Markup after the autocomplete is initiated:
 * 
 *  <ul class="ih-multi-autocomplete">
 *      <li class="ih-multi-autocomplete-item ih-multi-autocomplete-item-tag" data-value="12345">
 *          Stephen Gruenholz
 *          <input type="hidden" name="myinput[]" value="12345">
 *          <span class="ih-multi-autocomplete-tag-remove">&times;</span>
 *      </li>
 *      <li class="ih-multi-autocomplete-item ih-multi-autocomplete-item-input">
 *          <input type="text" id="myinput" name="myinput" class="ih-multi-autocomplete-input">
 *      </li>
 *      <li class="ih-multi-autocomplete-item ih-multi-autocomplete-input-helper" style="position: absolute; top:-9999px; left:-9999px; ">
 *      </li>
 *  </ul>
 * 
 * 
 * As selections are made, an li with a hidden input gets created for each selected item.
 * When the form posts, all the hidden input values are combined into an array
 * bacause they share a name like: myinput[].
 *
 */
(function($) {

    // redefine some things about the stock autocomplete widget
    // when minLength is zero, automatically search as soon as the input is focused.
    $.widget( "ui.autocomplete", $.ui.autocomplete, {
        _create: function() {

            // Cache any autocompete attr value - if one was provided, use it as the base
            // (we'll be adding a timestamp to enforce uniqueness - to defeat chrome autofill)
            var autocompleteAttr = this.element.attr("autocomplete");
            
            
            this._super();
            this._on(this.element, {
                "focus": function() {
                    if ( this.options.minLength === 0 ) {
                        this.search("", event);
                        
                        // if there's already a selected value ...
                        var value = this.element.val();
                        if ( value !== "" ) {
                            
                            // is it an exact match for one of the menu options?
                            // if so, highlight that menu option.
                            var $items = this.menu.element.children(".ui-menu-item");
                            var item = false;
                            $items.each( function() {
                                var text = $(this).text();
//                                console.log("text", text);
                                if ( value === text ) {
//                                    console.log("we have a match");
                                    // TODO: work in progress
//                                    item = $(this).data("ui-autocomplete-item");
                                    return false;
                                }
                            });
                            
                            var menu = this.menu;
                            
                            if ( item ) {
//                                setTimeout( function() {
//                                    menu.focus(null, item);
//                                }, 1000);
                                
                                this.menu.focus(null, item);
                            }
                        }
                        
                    }
                }
            });
            
            // defeat chrome autocomplete!
            
            // We don't want to use autocomplete="off" anymore since Chrome does not respect it,
            // and then proceeds to trample our autocomplete menu with their own.
            // Instead we use a value they don't recognize - e.g. "ih-component-zip" or similar.
            // But these get cached too so we have to randomize with a unique string - a timestamp
            
            if ( ! autocompleteAttr || autocompleteAttr == "off" ) {
                autocompleteAttr = "ih-component-autocomplete";
            }
            // timestamp it
            autocompleteAttr += Date.now();
            
            this.element.attr("autocomplete", autocompleteAttr);
            
        }//,
//        search: function() {
//            
//        }
    });




    // extend the jquery ui autocomplete widget to create a new
    // multiple selection autocomplete widget
    $.widget( "ih.multiautocomplete", $.ui.autocomplete, {
        options: {

            // wraps substring matches with <span class="ih-substring-match"></span> to allow for styling
            // (only for when source is initialized as an array. If using ajax, have the server return label values in that same format)
            substringMatch: true,

            // true, false, or "mixed": boolean whether to filter by string match on beginning only or match anywhere in string (default). 
            // "mixed" allows mixed results with matches on beginning of search string displayed first
            // (only for when source is initialized as an array. If using ajax, have the server handle this logic and return the appropriate results)
            matchOnBeginning: "mixed",

            // boolean to show the current search string as the first menu option. 
            // Subsequent selection of that item from the menu adds that new item to the selectedData array
            // even though it is not in the current source array 
            // These new items recieve an id of "_NEW_" + searchTerm.
            // (only for when source is initialized as an array. If using ajax, have the server handle this logic and return the appropriate results)
            suggestNew: false,

            // boolean
            // Assumes that the suggestNew is also true.
            // When typing, a comma will trigger a tag to close around whatever previous text is currently in the input
            // also, when pasting in a string value, it will accept a comma delimited string and parse it into multiple tags.
            // NOTE: you cannot use this if any of your menu values have a comma in them.
            closeTagOnComma: false,

            // set this to true to automatically highlight the first menu item anytime the menu opens
            // (when suggestNew is true, it will automatically turn on autoFocus as well)
//            autoFocus: false,

            initialItems: [], // array of initial pre-selected items { label:, value:, id: }

            // cache responses for search terms on the client side to prevent additional xhr requests.
            // NOTE: this only works when source is set to a URL string value. 
            // It's not applicable when using a client side source array or when using a custom function for source.
            cache: true
        },

        _create: function() {
            // private properties 
            this._inputName = "";
            this._inputValue = "";
            this._selectedData = [];
            this._cache = {};
            
            var that = this;

            // add a ul wrapper to hold the input and any tags. This is the "fake" input
            this.wrapper = $("<ul class='ih-multi-autocomplete ui-front'></ul>").insertAfter( this.element );

            // wrap the input inside an li and move it inside the ul wrapper
            this.li = $('<li class="ih-multi-autocomplete-item ih-multi-autocomplete-item-input"></li>').appendTo(this.wrapper);

            this.element.addClass("ih-multi-autocomplete-input").appendTo(this.li);

            // create a helper for resizing the original input
            // as you type in the input, the same characters get added to the helper, 
            // its width is measured and then applied to the input so that it shrink wraps its content.
            this.helper = $('<li class="ih-multi-autocomplete-item ih-multi-autocomplete-input-helper"></li>')
                .appendTo(this.wrapper)
                .css({
                    position: "absolute",
                    top: -9999,
                    left: -9999,
                    display: "block",
                    width: "auto",
                    color: "white",
                    fontSize: this.element.css("fontSize"),
                    fontFamily: this.element.css("fontFamily"),
                    fontWeight: this.element.css("fontWeight"),
                    letterSpacing: this.element.css("letterSpacing"),
                    whiteSpace: "nowrap"
                });

            // store and remove the name attribute
            this._inputName = this.element.attr("name");
            this.element.removeAttr("name");

            // if there is a placeholder attribute, remove it and create a helper to emulate it.
            this.placeholder = false;
            var placeholder = this.element.attr("placeholder");
            if (typeof placeholder !== typeof undefined && placeholder !== false) {
                this.placeholder = $('<li class="ih-multi-autocomplete-placeholder">' + placeholder + '</li>').appendTo(this.wrapper);
                this.element.removeAttr("placeholder");
            }

            // when the suggestNew option is on we always want that first menu item suggestion
            // selected by default when the menu opens
//            if ( this.options.suggestNew ) {
//                this.options.autoFocus = true;
//            }

            // default value for autocomplete field
            var autocompleteAttr = this.element.attr("autocomplete");
            if ( ! autocompleteAttr || autocompleteAttr == "off" ) {
                autocompleteAttr = "ih-component-multiautocomplete";
            }
            this.element.attr("autocomplete", autocompleteAttr);

            // do the normal autocomplete create stuff
            this._super();



            // populate any initial values from the input value if there is one.
            // expecting a comma delimited string of ids or values
            if ( this.element.val() !== "" ) {
                var initialValue = this.element.val();
                initialValue = initialValue.replace(/\, /g, ',');
                this.options.initialItems = initialValue.split(",");
                this.element.val(""); // clear out the value from the input
            }

            // if source is an array of strings, allow default values to be obtained 
            // from the initial value of the input (a comma delimited list of ids)
            if ( this.options.initialItems.length) {

                // if passing in a string of id's or values, and source is an array, 
                // try to lookup the missing item info from source.
                var matchOnId = ( typeof this.options.initialItems[0] === "string" && $.isArray( this.options.source ) );

                var initialItems = $.ih.multiautocomplete._normalizeItems(this.options.initialItems);
                $.each(initialItems, function(index, item) {

                    if (matchOnId) {
                        var sourceIndex = $.ih.multiautocomplete._indexOf( item, that.options.source );
                        if ( sourceIndex !== -1 ) {
                            item = that.options.source[sourceIndex];
                        }
                    }

                    that.addTag(item);
                });
            }

            // setup events

            // clicking anywhere on the wrapper always puts focus back on the input
            this._on(this.wrapper, {
                "click": function(e) {
                    this.element.focus();
                }
            });

            this._on(this.element, {
                "blur": function() {
                    this.resizeInput();
                    this.wrapper.removeClass("focus")
                        .children(".ih-selected").removeClass("ih-selected");
                },
                "focus": function() {
                    this.resizeInput();
                    this.wrapper.addClass("focus");
                },
                "keyup": function() {
                    this.resizeInput();
                    this.updatePlaceholder();
                },
                "keydown": function(e) {
                    // if there is a value in input
                    if ( this._value() !== "" ) {
                        
                        // if the menu is not active yet, and they hit enter,
                        // block the event so the form doesn't post
                        if ( e.which == 13 ) {
                            e.preventDefault();
                            if ( this.options.suggestNew ) {
                                this._change(e);
                            }
                        }
                        
                        // if typing a list of values, allow a comma to close the current tag
                        else if ( e.which == 188 && this.options.closeTagOnComma ) {
                            e.preventDefault();
                            this._change(e);
                        }
                    }
                    
                    this.resizeInput();
                    this.updatePlaceholder();
                    
                    // when the input is empty, and if there are any selected tags, 
                    // backspace once to select the last tag and one more time to remove it
                    if ( this.element.val() == "" && e.keyCode == 8 && this.wrapper.children(".ih-multi-autocomplete-tag").length ) {
                        var $lastTag = this.wrapper.children(".ih-multi-autocomplete-tag").last();
                        if ( $lastTag.hasClass("ih-selected") ) {
                            this.removeTag( $lastTag );
                            
                            if ( this.options.minLength === 0 ) {
                                this.search("", e);
                            }
                        }
                        else {
                            $lastTag.addClass("ih-selected");
                        }
                    }
                    // typing again will remove the selected state.
                    else {
                        this.wrapper.children(".ih-selected").removeClass("ih-selected");
                    }
                },
                "update": function() {
                    this.resizeInput();
                    this.updatePlaceholder();
                },
                "paste": function() {
                    
                    if ( this.options.closeTagOnComma ) {
                        var that = this;
                        
                        // delay gives the input a chance to set the new value
                        // after pasting
                        setTimeout( function() {
                            that._strToTags( that._value() );
                        }, 10);
                    }
                    
                }
            });

            this._on(this.wrapper, {
                "click.ih-multi-autocomplete-tag-remove": function(e) {
                    var tag = $(e.target).parent();
                    this.removeTag(tag);
                }
            });

            this._on( this.menu.element, {
                menuselect: function(e, ui) {
                    var item = ui.item.data("ui-autocomplete-item");
                    this.addTag( item );
                    
                    if ( this.options.minLength === 0 ) {
                        this.search("", e);
                    }
                }
            });

            this.resizeInput();
        },


        addTag: function(item) {
            //If there is nothing to add (just spaces, don't add tag

            if( typeof item.value === "string"  && item.value.trim() == ''){
                this.element.val("");
                this.resizeInput();
                this.updatePlaceholder();
                return;
            }
            var inputName = this._inputName + "[]";
            var item = $.ih.multiautocomplete._normalizeItem(item);
//            console.log("addTag", item);
            
            var value = item.id;
            var label = item.value;

            // append the new tag and a blank space text node
            $('<li class="ih-multi-autocomplete-item ih-multi-autocomplete-item-tag ih-multi-autocomplete-tag">' + 
                    label + ' <input type="hidden" name="' + inputName + '" value="' + value + '">' +
                    '<span class="ih-multi-autocomplete-tag-remove">&times;</span></li>')
                    .data("ui-autocomplete-item", item)
                    .insertBefore( this.li );

            this.element.val("");
            this.resizeInput();
            
            this._selectedData.push(item);
//            this._selectedData[item.id] = item;

//            console.log("_selectedData", this._selectedData);

            this.updatePlaceholder();

//            if ( this.options.minLength === 0 ) {
//                this.search("", event);
//            }
            
            // callback
            this._trigger("addTag", null, {
                item: item,
                selected: this._selectedData
            });
        },

        // remove the specified tag
        removeTag: function( tag ) {
            var item = tag.data("ui-autocomplete-item");
            this._removeDataItem(item);
            tag.remove();
            this.resizeInput();

            this.updatePlaceholder();
//            console.log("_selectedData", this._selectedData);

            // callback
            this._trigger("removeTag", null, {
                item: item,
                selected: this._selectedData
            });
        },

        updatePlaceholder: function() {
            if ( ! this.placeholder ) return;
            
            if ( this._inputValue !== "" || this._selectedData.length ) {
                this.placeholder.hide();
            }
            else {
                this.placeholder.show();
            }
        },

        // resize the original input when characters are added or removed from it
        resizeInput: function() {
            if ( this._inputValue === (this._inputValue = this.element.val()) ) {
                return;
            }

            // Enter new content into helper, measure, and resize visible input accordingly
            var escaped = this._inputValue.replace(/&/g, '&amp;').replace(/\s/g,' ').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            this.helper.html(escaped);
            this.element.width(this.helper.width() + 30);
        },

        _removeDataItem: function(item) {
            var index = $.ih.multiautocomplete._indexOf( item, this._selectedData );
            if ( index !== -1 ) {
                this._selectedData.splice(index, 1)[0];
            }
            else {
                console.error("the selected value is not in the selectedData array!");
            }

//            if ( this._selectedData[item.id] !== undefined ) {
//                delete this._selectedData[item.id];
//            }

            return item;
        },

        // overwriting parent method to better handle our suggestNew option.
        _change: function( event ) {
            
           // console.log("_change");
           // console.log('this', this);
           // console.log("prev", this.previous);
           // console.log("new", this._value() );
           // console.log("selectedItem", this.selectedItem );

            //this never fires because both values are blank
            if ( this.previous !== this._value() ) {
                
                // The menu appears after a brief delay, so if you type a value and then blur off the input,
                // make sure to convert that string to a tag if we're accepting non-menu values
                if ( ! this.selectedItem ) {
                    
//                    console.log("there is NOT a selectedItem");
                    
                    if ( this.options.suggestNew ) {
                        var item = $.ih.multiautocomplete._normalizeItem( this._value() );
                        this.addTag(item);
                        this.selectedItem = item;
                    }
                    else {
                        // clear out the value
                        this.element.val("");
                        return;
                    }
                }
                else {
//                    console.log("there IS a selectedItem");
                }

                //only fires on adding an item
                this._trigger( "change", event, { item: this.selectedItem } );
                //this._trigger( "change", event, { item: this.selectedItem, selected: this._selectedData } );

            }
        },

        // sorting should be done on the server before we get here, 
        // but if we're adding items on the fly to a locally cached array, we'll need this.
        sortData: function() {
            if ( this.options.source.length ) {
                // if it's an array of string values
                if ( typeof this.options.source[0] === "string" ) {
                    this.options.source.sort();
                }
                // else if it's an array of item objects sort by value
                else {
                    var compare = function(a, b) {
                        if (a.value < b.value)
                            return -1;
                        if (a.value > b.value)
                            return 1;
                        return 0;
                    }
                    this.options.source.sort(compare);
                }
            }
        },

        // cleanup events and reset DOM back to how it was
        destroy: function() {
            this._super();
        },

        // allow for client side filtering when this.options.source starts as an array so that 
        // a value that is already selected will not show up in the menu.
        _initSource: function() {
            
//            console.log("_initSource");
            
            var array;
            var url;
            var that = this;
            
            if ( $.isArray( this.options.source ) ) {
//                console.log("source is an array");
                
                array = this.options.source;
                this.source = function( request, response ) {
                    response( $.ih.multiautocomplete.filter( array, this._selectedData, request.term, this.options.matchOnBeginning, this.options.suggestNew ) );
                };
            }
            else if ( typeof this.options.source === "string" ) {
//                console.log("source is a string");
                
                url = this.options.source;
                this.source = function( request, response ) {
                    
                    // optionally use client side cache for this term if available
                    // to prevent additional XHR requests.
                    if ( this.options.cache && (request.term in this._cache) ) {
                        var data = this._cache[ request.term ];
                        response( $.ih.multiautocomplete.filter( data, that._selectedData, request.term, that.options.matchOnBeginning, that.options.suggestNew ) );
                        return;
                    }
                    
                    // aborts the current xhr request when making a new one
                    if ( that.xhr ) {
                        that.xhr.abort();
                    }
                    that.xhr = $.ajax({
                        url: url,
                        data: request,
                        dataType: "json",
                        success: function( data ) {
                            // optinally store response data in client side cache
                            if ( that.options.cache ) {
                                that._cache[ request.term ] = data;
                            }
                            response( $.ih.multiautocomplete.filter( data, that._selectedData, request.term, that.options.matchOnBeginning, that.options.suggestNew ) );
                        },
                        error: function() {
                            response([]);
                        }
                    });
                };
            } 
            else 
            {                
                this.source = this.options.source;
            }
        },


        // menu should be attached to the wrapper instead of the input
        _suggest: function( items ) {
            var ul = this.menu.element.empty();
            this._renderMenu( ul, items );
            this.isNewMenu = true;
            this.menu.refresh();

            // size and position menu
            ul.show();
            this._resizeMenu();
            ul.position( $.extend({
                of: this.wrapper
            }, this.options.position ) );

            if ( this.options.autoFocus || ( this.options.suggestNew && this._inputValue.length ) ) {
                this.menu.next();
            }
        },

        // size the menu to fit the wrapper instead of the input
        _resizeMenu: function() {
            var ul = this.menu.element;
            ul.outerWidth( Math.max(
                // Firefox wraps long text (possibly a rounding bug)
                // so we add 1px to avoid the wrapping (#7513)
                ul.width( "" ).outerWidth() + 1,
                this.wrapper.outerWidth() 
            ) );
        },

        // our substringMatch option injects a span with a class around the substring match
        // that can be used for styling
        // NOTE: this is a good candidate for adding as an extension to the regular autocomplete widget
        _renderItem: function( ul, item ) {
            // if item is a string
            var label = item;
            if ( item.label ) {
                // if item is an object with a label property
                label = item.label;
            }
            
            if ( this.options.substringMatch ) {
                var regex = $.ui.autocomplete.escapeRegex( this._inputValue );
                var matcher = new RegExp( regex, "i" );
                
                var match = matcher.exec(label);
                label = label.replace(match, '<span class="ih-substring-match">' + match + '</span>');
            }
            
            return $( "<li>" ).html( label ).appendTo( ul );
        },


        // takes a comma delimited string and creates tags for the values 
        _strToTags: function(string) {
            var values = $.ih.multiautocomplete._split(string);
            if ( values.length > 1 ) {
                for (var i=0; i < values.length; i++) {
                    if ( values[i] !== "" ) {
                        this.addTag(values[i]);
                    }
                }
            }
        },

        // if we need to change the name of the input dynamically
        rename: function(name) {
            this._inputName = name;
            var hiddenInputs = this.wrapper.find("input[type=hidden]").attr("name", this._inputName + "[]");
        }
    });


    // matchFront = true allows matching at only the beginning of the string
    // matchFront = "mixed" returns beginning string matches first and then all other results.
    // suggestNew will add an item to the beginning of the menu that matches the search string if there are no other exact matches
    $.extend( $.ih.multiautocomplete, {
        filter: function( array, selectedData, term, matchFront, suggestNew ) {
            var results = [];

//            console.log("filter");
//            console.log("filter(array, selectedData, term, matchFront, suggestNew)", array, selectedData, term, matchFront, suggestNew);
            
            // filter out any values that have already been selected
//            console.log("selectedData", selectedData);
            
            
            if ( suggestNew && term.length ) {
                
//                var item = { label: term + "...", value: term, id: "_NEW_" + term };
//                var item = term;
                
                var item = $.ih.multiautocomplete._normalizeItem(term, true);
//                console.log("item", item);
                
                // array is really an object like: 
                // {Sacramento: "Sacramento", Salida: "Salida", Salinas: "Salinas", San Andreas: "San Andreas", San Francisco: "San Francisco"…}
//                console.log("array", array);
//                console.log("selectedData", selectedData);
                
                if ( $.ih.multiautocomplete._indexOf( item, array ) == -1 && $.ih.multiautocomplete._indexOf( item, selectedData ) == -1 ) {
                    results.push(item);
                }
            }

            var term = $.ui.autocomplete.escapeRegex( term );

            if ( matchFront == "mixed" ) {
                var matcher = new RegExp( term, "i" );
                var frontMatcher = new RegExp( "^" + term, "i" );
                var otherResults = [];

                $.each(array, function( index, item ) {
                    if ( matcher.test( item.label || item.value || item ) ) {
                        if ( frontMatcher.test( item.label || item.value || item ) ) {
                            results.push(item);
                        }
                        else {
                            otherResults.push(item);
                        }
                    }
                });
                $.each(otherResults, function(index, item) {
                    results.push(item);
                });
            }
            else {
                var regex = term;
                if ( matchFront ) {
                    regex = "^" + term;
                }
                var matcher = new RegExp( regex, "i" );
                results = $.grep( array, function( item ) {
                    return matcher.test( item.label || item.value || item );
                });
            }

            // filter out any results that are already in the selectedData object
            if ( selectedData.length ) {
                $.each(selectedData, function(key, item) {
                    var index = $.ih.multiautocomplete._indexOf( item, results );
                    if ( index !== -1 ) {
//                        console.log("found item in results, filtering it out!", item, results);
                        results.splice(index, 1)[0];
                    }
                });
            }
            
            return results;
        },

        // returns the index of the array item that matches the value
        // or -1 if not found
        _indexOf: function( item, array ) {
            if ( item === "" ) return -1;
            var index = -1;
            
            if ( array.length ) {
                    for(var i=0, len=array.length; i<len; i++) {
                        
                        // array iteration is a string
                        if ( typeof array[i] == "string" ) {
                            
                            // item is a string
                            if ( typeof item == "string" ) {
                                if (index == item) {
                                    index = i;
                                    break;
                                }
                            }
                            // item is an object
                            else {
                                // find by id
                                if ( item.id !== undefined && array[i] == item.id) {
                                    index = i;
                                    break;
                                }
                                // find by value.
                                else if ( item.value !== undefined && array[i] == item.value ) {
                                    index = i;
                                    break;
                                }
                                // find by label
                                else if ( item.label !== undefined && array[i] == item.label ) {
                                    index = i;
                                    break;
                                }
                            }
                        }
                        
                        // array iteration is an object
                        else {
                            // item is a string
                            if ( typeof item == "string" ) {
                                // find by id
                                if ( array[i].id == item) {
                                    index = i;
                                    break;
                                }
                                // find by value.
                                else if ( array[i].value == item ) {
                                    index = i;
                                    break;
                                }
                                // find by label
                                else if ( array[i].label == item ) {
                                    index = i;
                                    break;
                                }
                            }
                            // item is an object
                            else {
                                // find by id
                                if ( item.id !== undefined && array[i].id == item.id) {
                                    index = i;
                                    break;
                                }
                                // find by value.
                                else if ( item.value !== undefined && array[i].value == item.value ) {
                                    index = i;
                                    break;
                                }
                                // find by label
                                else if ( array[i].label == item.label ) {
                                    index = i;
                                    break;
                                }
                            }
                        }
                    }
                }
//            }
            return index;
        },
        
        // add an extra "id" property in addition to label and value
        _normalizeItems: function( items ) {
            // assume all items have the right format when the first item is complete
            if ( items.length && items[ 0 ].label && items[ 0 ].value && items[ 0 ].id ) {
                return items;
            }
            return $.map( items, function( item ) {
                return $.ih.multiautocomplete._normalizeItem(item);
            });
        },

        _normalizeItem: function(item, suggestNew) {
            if ( typeof item === "string" ) {
                return {
                    label: (suggestNew) ? item + "&hellip;" : item,
                    value: item,
                    id: item
                };
            }
            return $.extend( {}, item, {
                label: item.label || item.value,
                value: item.value || item.label,
                id: item.id || item.value || item.label
            });
        },

        // takes a comma delimited string and returns an array
        _split: function(string) {
            var values = [];
            var string = String(string);
            
            if ( string && string.length > 0 ) {
                values = string.split( /,\s*/ );
                
                if ( values.length > 1 ) {
                    for (var i=0; i < values.length; i++) {
                        values[i] = ih.utils.strip(values[i]);
                    }
                }
            }
            return values;
        }
    });


})(jQuery);
